import React from 'react';
import propTypes from './propTypes';

const ScoutReports = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17 3H13.82C13.4 1.84 12.3 1 11 1C9.7 1 8.6 1.84 8.18 3H5C3.9 3 3 3.9 3 5V20C3 21.1 3.9 22 5 22H11.11C10.52 21.43 10.04 20.75 9.69 20H5V5H7V7H15V5H17V10.08C17.71 10.18 18.38 10.39 19 10.68V5C19 3.9 18.1 3 17 3ZM11 5C10.45 5 10 4.55 10 4C10 3.45 10.45 3 11 3C11.55 3 12 3.45 12 4C12 4.55 11.55 5 11 5Z" fill="currentColor" />
    <rect x="10" y="10" width="5" height="2" fill="currentColor" />
    <rect x="7" y="10" width="2" height="2" rx="1" fill="currentColor" />
    <rect x="7" y="14" width="2" height="2" rx="1" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M22.5 14.5L21 13L15.51 18.5L12.5 15.5L11 17L15.51 21.5L22.5 14.5Z" fill="currentColor" />
  </svg>
);

ScoutReports.propTypes = propTypes;

export default ScoutReports;
